import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class PointageAnomalieEvent extends UserEvent {
  public static NAME = 'POINTAGE_ANOMALIE_EVENT';

  constructor(
    public idCreneau: string,
    public idVacation: string,
    public idPointeau: string,
    public iteration: number,
    public parcours: boolean,
    public texte: string,
    public photos: string[],
    public avecZone: boolean,
    public idZone: string | undefined,
    instant: dayjs.Dayjs,
    coordinates?: Coordinates
  ) {
    super(PointageAnomalieEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: PointageAnomalieEvent): PointageAnomalieEvent {
    return new PointageAnomalieEvent(
      obj.idCreneau,
      obj.idVacation,
      obj.idPointeau,
      obj.iteration,
      obj.parcours,
      obj.texte,
      obj.photos,
      obj.avecZone,
      obj.idZone,
      dayjs(obj.instant),
      obj.coordinates
    );
  }
}
